<template>
  <v-breadcrumbs :items="breadcrumbs" divider="/" class="app_bar_text_color--text" />
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'BreadCrumbs',
    watch: {
      $route() {
        this.addBreadCrumbs()
      },
      locale() {
        this.setBreadcrumbs([])
        this.addBreadCrumbs()
      },
    },
    mounted() {
      this.setBreadcrumbs([])
      this.addBreadCrumbs()
    },
    computed: {
      ...mapState(['breadcrumbs', 'locale']),
      notDisplayFullBreadcrumbs() {
        return this.$vuetify.breakpoint.width < 650
      },
    },
    methods: {
      ...mapActions(['setBreadcrumbs']),
      addBreadCrumbs() {
        let breadcrumbsExist = this.breadcrumbs.find((item) => item.to === this.$route.path)
        let breadcrumbs = this.breadcrumbs
        let breadcrumbsMeta = this.$route.meta.breadcrumbs
        let parentBreadcrumbs = this.$route.meta.parentBreadcrumbs

        if (breadcrumbsMeta) {
          if (!breadcrumbsExist) {
            if (this.breadcrumbs.length && breadcrumbsMeta.reset) {
              this.setBreadcrumbs([])
              breadcrumbs = this.breadcrumbs
            }

            let tradParams = {}

            for (let params in this.$route.params) {
              if (params === 'type' && this.$route.name == 'appointments') {
                tradParams[params] = this.$t('breadcrumbs.' + this.$route.params[params])
              } else if (
                ['id', 'idVariant'].includes(params) &&
                ['unifiedStockDetails', 'unifiedStockVariantTable'].includes(this.$route.name)
              ) {
                tradParams['product_id'] = this.$route.params[params].replace('%20', ' ')
              } else {
                if (typeof this.$route.params[params] === 'string') {
                  tradParams[params] = this.$route.params[params].replace('%20', ' ')
                }
              }
            }

            let text = ''
            if (!['userEdit', 'TriggersDetail'].includes(this.$route.name)) {
              text = this.$t('breadcrumbs.' + breadcrumbsMeta.label, tradParams)
            }

            if (!this.notDisplayFullBreadcrumbs) {
              if (parentBreadcrumbs && !this.breadcrumbs.length) {
                for (let parentBreadcrumb of parentBreadcrumbs) {
                  let parentBreadcrumbsExist = this.breadcrumbs.find((item) => item.to === parentBreadcrumb.to)
                  let url = parentBreadcrumb.to
                  if (this.$route.params) {
                    for (let param in this.$route.params) {
                      if (parentBreadcrumb.to.search(param) !== -1) {
                        url = parentBreadcrumb.to.replace(':' + param, this.$route.params[param])
                      }
                    }
                  }
                  if (!parentBreadcrumbsExist) {
                    let parentBreadcrumbsText = this.$t('breadcrumbs.' + parentBreadcrumb.label, tradParams)
                    breadcrumbs.push({
                      text: parentBreadcrumbsText,
                      to: url,
                      exact: true,
                      lastElement: false,
                    })
                  }
                }
              }
            } else {
              breadcrumbs = []
            }

            breadcrumbs.push({
              text: text,
              to: this.$route.path,
              exact: true,
              lastElement: true,
            })

            this.setBreadcrumbs(breadcrumbs)
          } else if (breadcrumbsExist) {
            let breadCrumbIndex = this.breadcrumbs.findIndex((item) => item.to === this.$route.path)
            breadcrumbs = breadcrumbs.splice(breadCrumbIndex + 1, this.breadcrumbs.length)
          }
        } else {
          this.setBreadcrumbs([])
        }
      },
    },
  }
</script>
